// OSIS GROUP FLOOR SRL - Routes Configuration - Versiune Completă cu toate paginile
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from '../layouts/DashboardLayout';

// ========== PRODUCȚIE & FABRICAȚIE ==========
import ProductionDashboard from '../pages/Production/ProductionDashboard';
import ProductionOrders from '../pages/Production/ProductionOrders';
import MaterialsManagement from '../pages/Production/MaterialsManagement';
import QualityControl from '../pages/Production/QualityControl';
import EquipmentManagement from '../pages/Production/EquipmentManagement';
import ProductionPlanning from '../pages/Production/ProductionPlanning';

// ========== PROIECTARE & TEHNICĂ ==========
import EngineeringProjects from '../pages/Engineering/EngineeringProjects';
import ClientMeasurements from '../pages/Engineering/ClientMeasurements';
import TechnicalDrawings from '../pages/Engineering/TechnicalDrawings';
import StructuralCalculations from '../pages/Engineering/StructuralCalculations';
import StandardsLibrary from '../pages/Engineering/StandardsLibrary';

// ========== INSTALARE & MONTAJ ==========
import InstallationTeams from '../pages/Installation/InstallationTeams';
import InstallationTracking from '../pages/Installation/InstallationTracking';
import InstallationTools from '../pages/Installation/InstallationTools';
import InstallationReports from '../pages/Installation/InstallationReports';
import InstallationSchedule from '../pages/Installation/InstallationSchedule';

// ========== VÂNZĂRI & CRM ==========
import SalesDashboard from '../pages/Sales/SalesDashboard';
import PriceCalculator from '../pages/Sales/PriceCalculator';
import ClientsCRM from '../pages/Sales/ClientsCRM';
import SalesAnalytics from '../pages/Sales/SalesAnalytics';
import IstoricComenzi from '../pages/Sales/IstoricComenzi';
import IntegrareLogistica from '../pages/Sales/IntegrareLogistica';
import OptimizareStocuri from '../pages/Sales/OptimizareStocuri';
import PreviziuneVanzari from '../pages/Sales/PreviziuneVanzari';
import RaportareAutomata from '../pages/Sales/RaportareAutomata';

// ========== STOCURI & LOGISTICĂ ==========
import InventoryDashboard from '../pages/Inventory/InventoryDashboard';
import ProfilesStock from '../pages/Inventory/ProfilesStock';
import SuppliersManagement from '../pages/Inventory/SuppliersManagement';
import GlassStock from '../pages/Inventory/GlassStock';
import HardwareStock from '../pages/Inventory/HardwareStock';
import MaterialProcurement from '../pages/Inventory/MaterialProcurement';

// ========== RESURSE UMANE ==========
import PortalAngajati from '../pages/HR/PortalAngajati';
import PlanificatorConcedii from '../pages/HR/PlanificatorConcedii';
import EvaluarePerformanta from '../pages/HR/EvaluarePerformanta';
import PlatformaElearning from '../pages/HR/PlatformaElearning';
import OrganigramaDigitala from '../pages/HR/OrganigramaDigitala';
import HRDocuments from '../pages/HR/HRDocuments';
import GestionareCVuri from '../pages/HR/GestionareCVuri';

// ========== FINANCIAR & CONTABILITATE ==========
import EmitereFacturi from '../pages/Accounting/EmitereFacturi';
import CheltuieliOperationale from '../pages/Accounting/CheltuieliOperationale';
import IntegrareOffice360 from '../pages/Accounting/IntegrareOffice360';
import ManagementDocumente from '../pages/Accounting/ManagementDocumente';
import MigrareDate from '../pages/Accounting/MigrareDate';
import RapoarteFinanciare from '../pages/Accounting/RapoarteFinanciare';
import UrmarirePlati from '../pages/Accounting/UrmarirePlati';
import VerificareDiscrepante from '../pages/Accounting/VerificareDiscrepante';

// ========== CRM & AUTOMATIZARE ==========
import CRMComplet from '../pages/CRM/CRMComplet';
import AnalizaPredictiva from '../pages/CRM/AnalizaPredictiva';
import AutomatizareRPA from '../pages/CRM/AutomatizareRPA';
import Chatbot247 from '../pages/CRM/Chatbot247';
import IntegrareWhatsApp from '../pages/CRM/IntegrareWhatsApp';

// ========== MARKETING & COMUNICARE ==========
import CampaniiEmail from '../pages/Marketing/CampaniiEmail';
import GenerareContinutAI from '../pages/Marketing/GenerareContinutAI';
import AnalizaPerformantaMarketing from '../pages/Marketing/AnalizaPerformantaMarketing';
import AdaptareLaPiata from '../pages/Marketing/AdaptareLaPiata';
import WebsitePortfolio from '../pages/Marketing/WebsitePortfolio';

// ========== SECURITATE & MONITORIZARE ==========
import DetectareAmenintari from '../pages/Security/DetectareAmenintari';
import Monitorizare247 from '../pages/Security/Monitorizare247';
import RaportareIncidente from '../pages/Security/RaportareIncidente';
import RaspunsAutomatizat from '../pages/Security/RaspunsAutomatizat';

// ========== CLOUD STORAGE ==========
import CloudDashboard from '../pages/Cloud/CloudDashboard';
import CloudFiles from '../pages/Cloud/CloudFiles';
import CloudUpload from '../pages/Cloud/CloudUpload';
import CloudBackup from '../pages/Cloud/CloudBackup';
import CloudSettings from '../pages/Cloud/CloudSettings';

// ========== INTEGRĂRI OFFICE ==========
import Microsoft365Integration from '../pages/Integrations/Microsoft365Integration';
import TeamsIntegration from '../pages/Integrations/TeamsIntegration';
import ZoomIntegration from '../pages/Integrations/ZoomIntegration';
import SharePointIntegration from '../pages/Integrations/SharePointIntegration';
import OutlookIntegration from '../pages/Integrations/OutlookIntegration';

// ========== ENTERPRISE & RAPOARTE ==========
import ExecutiveDashboard from '../pages/Enterprise/ExecutiveDashboard';
import AdvancedReportingEngine from '../pages/Enterprise/AdvancedReportingEngine';
import WorkflowAutomationEngine from '../pages/Enterprise/WorkflowAutomationEngine';
import EnterpriseOverview from '../pages/Enterprise/EnterpriseOverview';

// Placeholder component pentru paginile în dezvoltare
const OsisPlaceholderPage = ({ title, description, module, icon, status = "În dezvoltare" }) => (
  <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center py-16">
        <div className="flex justify-center mb-6">
          <div className="flex items-center justify-center w-20 h-20 bg-gradient-to-br from-primary-500 to-secondary-500 rounded-2xl">
            <div className="text-white text-3xl">{icon}</div>
          </div>
        </div>
        
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">{title}</h1>
        <p className="text-xl text-gray-600 dark:text-gray-400 mb-8 max-w-2xl mx-auto">{description}</p>
        
        <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 max-w-md mx-auto shadow-strong border border-gray-200 dark:border-gray-700">
          <div className="flex items-center justify-center w-12 h-12 bg-primary-100 dark:bg-primary-900 rounded-xl mx-auto mb-4">
            <div className="w-6 h-6 text-primary-600">⚙️</div>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">{status}</h3>
          <p className="text-gray-600 dark:text-gray-400 text-sm mb-4">
            {status === "Implementat 100%"
              ? "Funcționalitatea este complet implementată și disponibilă pentru OSIS GROUP FLOOR SRL."
              : "Această funcționalitate este în curs de dezvoltare și va fi disponibilă în curând."
            }
          </p>
          <div className={`rounded-lg p-3 ${status === "Implementat 100%" ? 'bg-green-50 dark:bg-green-900/30' : 'bg-yellow-50 dark:bg-yellow-900/30'}`}>
            <p className={`text-xs font-medium ${status === "Implementat 100%" ? 'text-green-700 dark:text-green-300' : 'text-yellow-700 dark:text-yellow-300'}`}>
              Modul: {module} {status === "Implementat 100%" ? '✅' : '🚧'}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DashboardLayout />}>
          {/* Redirect root to production dashboard */}
          <Route index element={<Navigate to="/production/orders" replace />} />
          
          {/* ========== MODULUL PRODUCȚIE & FABRICAȚIE ========== */}
          <Route path="production/orders" element={<ProductionDashboard />} />
          <Route path="production/materials" element={<MaterialsManagement />} />
          <Route path="production/quality" element={<QualityControl />} />
          <Route path="production/equipment" element={<EquipmentManagement />} />
          <Route path="production/planning" element={<ProductionPlanning />} />

          {/* ========== MODULUL PROIECTARE & TEHNICĂ ========== */}
          <Route path="engineering/projects" element={<EngineeringProjects />} />
          <Route path="engineering/measurements" element={<ClientMeasurements />} />
          <Route path="engineering/drawings" element={<TechnicalDrawings />} />
          <Route path="engineering/calculations" element={<StructuralCalculations />} />
          <Route path="engineering/standards" element={<StandardsLibrary />} />

          {/* ========== MODULUL INSTALARE & MONTAJ ========== */}
          <Route path="installation/schedule" element={<InstallationSchedule />} />
          <Route path="installation/teams" element={<InstallationTeams />} />
          <Route path="installation/tracking" element={<InstallationTracking />} />
          <Route path="installation/tools" element={<InstallationTools />} />
          <Route path="installation/reports" element={<InstallationReports />} />

          {/* ========== MODULUL VÂNZĂRI & CRM ========== */}
          <Route path="sales/dashboard" element={<SalesDashboard />} />
          <Route path="sales/calculator" element={<PriceCalculator />} />
          <Route path="sales/clients" element={<ClientsCRM />} />
          <Route path="sales/analytics" element={<SalesAnalytics />} />
          <Route path="sales/orders" element={<IstoricComenzi />} />
          <Route path="sales/logistics" element={<IntegrareLogistica />} />
          <Route path="sales/inventory-opt" element={<OptimizareStocuri />} />
          <Route path="sales/forecasting" element={<PreviziuneVanzari />} />
          <Route path="sales/reports" element={<RaportareAutomata />} />

          {/* ========== MODULUL STOCURI & LOGISTICĂ ========== */}
          <Route path="inventory/dashboard" element={<InventoryDashboard />} />
          <Route path="inventory/profiles" element={<ProfilesStock />} />
          <Route path="inventory/suppliers" element={<SuppliersManagement />} />
          <Route path="inventory/glass" element={<GlassStock />} />
          <Route path="inventory/hardware" element={<HardwareStock />} />
          <Route path="inventory/procurement" element={<MaterialProcurement />} />

          {/* ========== MODULUL RESURSE UMANE ========== */}
          <Route path="hr/portal" element={<PortalAngajati />} />
          <Route path="hr/vacations" element={<PlanificatorConcedii />} />
          <Route path="hr/performance" element={<EvaluarePerformanta />} />
          <Route path="hr/elearning" element={<PlatformaElearning />} />
          <Route path="hr/organigram" element={<OrganigramaDigitala />} />
          <Route path="hr/documents" element={<HRDocuments />} />
          <Route path="hr/cv-management" element={<GestionareCVuri />} />

          {/* ========== MODULUL FINANCIAR & CONTABILITATE ========== */}
          <Route path="accounting/invoices" element={<EmitereFacturi />} />
          <Route path="accounting/expenses" element={<CheltuieliOperationale />} />
          <Route path="accounting/payments" element={<UrmarirePlati />} />
          <Route path="accounting/payment-tracking" element={<UrmarirePlati />} />
          <Route path="accounting/reports" element={<RapoarteFinanciare />} />
          <Route path="accounting/discrepancies" element={<VerificareDiscrepante />} />
          <Route path="accounting/documents" element={<ManagementDocumente />} />
          <Route path="accounting/invoice-generation" element={<EmitereFacturi />} />
          <Route path="accounting/data-migration" element={<MigrareDate />} />
          <Route path="accounting/office365" element={<IntegrareOffice360 />} />

          {/* ========== MODULUL CRM & AUTOMATIZARE ========== */}
          <Route path="crm/complete" element={<CRMComplet />} />
          <Route path="crm/predictive" element={<AnalizaPredictiva />} />
          <Route path="crm/automation" element={<AutomatizareRPA />} />
          <Route path="crm/chatbot" element={<Chatbot247 />} />
          <Route path="crm/whatsapp" element={<IntegrareWhatsApp />} />

          {/* ========== MODULUL MARKETING & COMUNICARE ========== */}
          <Route path="marketing/email" element={<CampaniiEmail />} />
          <Route path="marketing/content-ai" element={<GenerareContinutAI />} />
          <Route path="marketing/analytics" element={<AnalizaPerformantaMarketing />} />
          <Route path="marketing/market-adapt" element={<AdaptareLaPiata />} />
          <Route path="marketing/website" element={<WebsitePortfolio />} />

          {/* ========== MODULUL SECURITATE & MONITORIZARE ========== */}
          <Route path="security/threats" element={<DetectareAmenintari />} />
          <Route path="security/monitoring" element={<Monitorizare247 />} />
          <Route path="security/incidents" element={<RaportareIncidente />} />
          <Route path="security/response" element={<RaspunsAutomatizat />} />

          {/* ========== MODULUL CLOUD STORAGE ========== */}
          <Route path="cloud/dashboard" element={<CloudDashboard />} />
          <Route path="cloud/files" element={<CloudFiles />} />
          <Route path="cloud/upload" element={<CloudUpload />} />
          <Route path="cloud/backup" element={<CloudBackup />} />
          <Route path="cloud/settings" element={<CloudSettings />} />

          {/* ========== MODULUL INTEGRĂRI OFFICE ========== */}
          <Route path="integrations/microsoft365" element={<Microsoft365Integration />} />
          <Route path="integrations/teams" element={<TeamsIntegration />} />
          <Route path="integrations/zoom" element={<ZoomIntegration />} />
          <Route path="integrations/sharepoint" element={<SharePointIntegration />} />
          <Route path="integrations/outlook" element={<OutlookIntegration />} />

          {/* ========== MODULUL ENTERPRISE & RAPOARTE ========== */}
          <Route path="enterprise/dashboard" element={<ExecutiveDashboard />} />
          <Route path="enterprise/reporting" element={<AdvancedReportingEngine />} />
          <Route path="enterprise/workflow" element={<WorkflowAutomationEngine />} />
          <Route path="enterprise/overview" element={<EnterpriseOverview />} />

          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/production/orders" replace />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRoutes;